var map = {
	"./auth-bg.png": 9488,
	"./avatar.png": 4367,
	"./background.png": 1964,
	"./field/field1.png": 5798,
	"./field/field10.jpg": 7920,
	"./field/field2.png": 3213,
	"./field/field3.jpg": 2928,
	"./field/field4.jpg": 4579,
	"./field/field5.jpg": 2406,
	"./field/field6.jpg": 3825,
	"./field/field7.jpg": 6452,
	"./field/field8.jpg": 3927,
	"./field/field9.jpg": 1770,
	"./player/avatar1.jpg": 1610,
	"./player/avatar10.jpg": 2584,
	"./player/avatar11.jpg": 9845,
	"./player/avatar12.jpg": 2506,
	"./player/avatar13.jpg": 1511,
	"./player/avatar14.jpg": 7724,
	"./player/avatar15.jpg": 1449,
	"./player/avatar16.jpg": 8958,
	"./player/avatar17.jpg": 5419,
	"./player/avatar18.jpg": 512,
	"./player/avatar19.jpg": 3965,
	"./player/avatar2.jpg": 4213,
	"./player/avatar20.jpg": 8537,
	"./player/avatar3.jpg": 1848,
	"./player/avatar4.jpg": 4523,
	"./player/avatar5.jpg": 9742,
	"./player/avatar6.jpg": 3449,
	"./player/avatar7.jpg": 8076,
	"./player/avatar8.jpg": 2671,
	"./player/avatar9.jpg": 4738,
	"./player/background.png": 1892,
	"./player/default.png": 8897,
	"./shield1.png": 5698,
	"./shield2.png": 3881,
	"./shield3.png": 6976,
	"./поле2.png": 4029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;